import { BaseModal } from "@/components/modal/base-modal";
import { SwapPickItem } from "@/features/meal-plan/components/swap-pick-item";
import { useGetFruitPicks } from "@/hooks/requests/meal/use-get-fruit-picks";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

interface FruitPicksBottomSheetProps {
  isOpen: boolean;
  onDismiss: () => void;
}

export const FruitPicksBottomSheet = memo(function FruitPicksBottomSheet({
  isOpen,
  onDismiss,
}: FruitPicksBottomSheetProps) {
  const { fruitPicks, isLoading } = useGetFruitPicks();

  return (
    <BaseModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      backdropDismiss={true}
      initialBreakpoint={0.6}
      breakpoints={[0, 0.6, 1]}
      handle={true}
    >
      <div className="flex flex-col gap-4 overflow-y-auto px-7 pt-6 pb-20">
        <h2 className={cn(textVariants.title3, "text-center")}>Your Fruit Picks</h2>

        {isLoading ? (
          <div className="flex flex-wrap justify-between gap-2">
            {[...Array(6)].map((_, index) => (
              <IonSkeletonText key={index} animated className="h-48 w-full rounded-2xl" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-2">
            {fruitPicks?.fruitPicks?.map((fruit, index) => (
              <SwapPickItem
                key={index}
                imageUrl={fruit.imageUrl}
                name={fruit.name}
                description={fruit.quantity}
              />
            ))}
          </div>
        )}
      </div>
    </BaseModal>
  );
});
